import { DataDRequest } from "./DRequest";
import { Entidad } from "./Entidad";
import { ICicloEscolar } from "./entidad/CicloEscolar";
import { IEscolaridad } from "./entidad/Escolaridad";
import { IEscuela } from "./entidad/Escuela";
import { IGrado } from "./entidad/Grado";
import { IGrupo } from "./entidad/Grupo";
import { ILicencia } from "./entidad/LicenciaOld";
import { MEscuela } from "./model/MEscuela";
import { _DICC_ALUMNO, _DICC_ALUMNO_ESTADO, _SvAlumnoObtenerInfoBajaTemporalLista, _SvAlumnoObtenerLista } from "./modulo/Alumno";
import { _DICC_TUTOR_ASIGNACIONES, _SvPadreObtenerAsignacionesAlumno } from "./modulo/AlumnoTutorAsignacion";
import { _DICC_AYUDA, _SvAyudaObtenerLista } from "./modulo/Ayuda";
import { _DICC_CICLO_ESCOLAR, _SvCicloEscolarObtenerLista } from "./modulo/CicloEscolar";
import { _DictCuentaBancaria, _GetList as _GetListCuentaBancaria } from "./modulo/CuentaBancaria";
import { _DictCategorias, _GetList as _GetListEgresoCategoria } from "./modulo/EgresoCategoria";
import { _DictEgresosPredefinidos, _GetList as _GetListEgresoPredefinido } from "./modulo/EgresoPredefinido";
import { _DICC_ESCOLARIDAD, _SvEscolaridadObtenerLista } from "./modulo/Escolaridad";
import { _DICC_ESCUELA, _SvEscuelaObtenerLista } from "./modulo/Escuela";
import { _DiccEscuelaAlumnoInfoExtra, _GetAlumnosInfoExtraList as _GetListEscuelaAlumnoInfoExtra } from "./modulo/EscuelaAlumnoInfoExtra";
import { _DICC_FINANZAS_CARGOS, _SvFinanzasObtenerListaCargos } from "./modulo/FinanzaCargo";
import { _DICC_HORAS_EXTRAS, _SvFinanzasObtenerListaHorasExtra } from "./modulo/FinanzaHoraExtra";
import { _DICC_METODO_PAGO, _SvMetodoPagoObtenerLista } from "./modulo/FinanzaMetodoPago";
import { _DICC_GRADO, _SvGradoObtenerLista } from "./modulo/Grado";
import { _DICC_GRUPO, _SvGrupoObtenerLista } from "./modulo/Grupo";
import { _DICC_ALUMNO_HORARIO_ASIGNACION, _SvHorarioObtenerLista } from "./modulo/HorarioAlumno";
import { _DICC_LICENCIA, _SvLicenciaObtenerLista } from "./modulo/LicenciaOld";
import { _DICC_LOGROS, _SvLogroObtenerLista } from "./modulo/Logro";
import { _DICC_LOGRO_ASIGNACIONES, _SvLogroObtenerListaAsignacion } from "./modulo/LogroAsignacion";
import { _DICC_LOGRO_CATEGORIAS, _SvLogroCategoriaObtenerLista } from "./modulo/LogroCategoria";
import { _DICC_MAESTROS, _SvMaestroObtenerLista } from "./modulo/Maestro";
import { _DiccMateriasV2, _GetList as _GetListMateriaV2 } from "./modulo/MateriaV2";
import { _DICC_NOTICIA, _SvNoticiaObtenerLista } from "./modulo/Noticia";
import { _DictProveedor, _GetList as _GetListProveedor } from "./modulo/Proveedor";
import { ISesionVigencia, _DICC_SESION_VIGENCIA, _SvSesionVerificarSesion } from "./modulo/Sesion";
import { _DICC_TUTORES, _SvTutorObtenerLista } from "./modulo/Tutor";
import { _DiccUsuarios, _GetList as _GetListUsuario } from "./modulo/Usuario";
import { DataRequestWKList } from "./util/DRequestWKList";
import { DataUtil } from "./util/Util";

/** Control de modulos monitoreables (MM), Los datos de cada MM...
 * * Se obtienen de un servicio desde una función especifica
 * * Se guardan en indexDB (opcinal)
 *     - Nota: Si están disponibles en indexDB, el proximo reload inicia con esos datos
 * * Se guardan en un Map
 * * Pueden ser invocados manualmente, disparando los puntos anteriores
 * * Se consultan cada N milisegundos en el worker (opcional)
*/
export namespace DataModuloMain {
    import CTypeRequest = Entidad.CTipoRequest;
    type OmitEntity = undefined;

    export type TTypeRequestEntitiesMap = {
        [k in CTypeRequest]: (
            k extends CTypeRequest.Escuela ? IEscuela
            : k extends CTypeRequest.Alumno ? Entidad.IAlumno
            : k extends CTypeRequest.LogroCategoria ? Entidad.ILogroCategoria
            : k extends CTypeRequest.Tutor ? Entidad.ITutor
            : k extends CTypeRequest.Grupo ? IGrupo
            : k extends CTypeRequest.Grado ? IGrado
            : k extends CTypeRequest.Logro ? Entidad.ILogro
            : k extends CTypeRequest.LogroAsignacion ? Entidad.ILogroAsignacion
            : k extends CTypeRequest.TutorAsignacion ? Entidad.ITutorAsignacion
            : k extends CTypeRequest.HorarioAlumno ? Entidad.IAlumnoHorarioAsignacion
            // : k extends CTypeRequest.UsuarioPermisos ? never // NEVER
            : k extends CTypeRequest.Circular ? Entidad.ICircular
            // : k extends CTypeRequest.Archivo ? never // NEVER
            : k extends CTypeRequest.Escolaridad ? IEscolaridad
            // : k extends CTypeRequest.Finanzas ? never // NEVER
            : k extends CTypeRequest.FinanzaCargo ? Entidad.IFinanzaCargo
            : k extends CTypeRequest.Sesion ? ISesionVigencia
            : k extends CTypeRequest.CicloEscolar ? ICicloEscolar
            : k extends CTypeRequest.FinanzaMetodoPago ? Entidad.IFinanzaMetodoPago
            : k extends CTypeRequest.FinanzaHoraExtra ? Entidad.IFinanzaItemHoraExtra
            : k extends CTypeRequest.Usuario ? Entidad.IUsuario
            : k extends CTypeRequest.Ayuda ? Entidad.IAyuda
            : k extends CTypeRequest.Maestro ? Entidad.IMaestro
            : k extends CTypeRequest.EscuelaAlumnoInfoExtra ? Entidad.IEscuelaConfigInfoExtra
            : k extends CTypeRequest.EgresoPredefinido ? Entidad.IFinanzaEgresoPredefinido
            : k extends CTypeRequest.CuentaBancaria ? Entidad.IFinanzaCuentaBancaria
            : k extends CTypeRequest.Proveedor ? Entidad.IFinanzaProveedor
            : k extends CTypeRequest.MateriaV2 ? Entidad.IMateria
            : k extends CTypeRequest.EgresoCategoria ? Entidad.IFinanzasEgresoCategoria
            : k extends CTypeRequest.Licencia ? ILicencia
            : k extends CTypeRequest.AlumnoEstado ? Entidad.IAlumnoEstado
            // : k extends CTypeRequest.EgresoMovimiento ? Entidades.IFinanzaEgresoMovimiento
            : OmitEntity
        )
    }

    export type TipoRequestMonitorId = {
        [k in keyof typeof CTypeRequest]: (TTypeRequestEntitiesMap[typeof CTypeRequest[k]]) extends OmitEntity ? never : (typeof CTypeRequest)[k]
    }[keyof typeof CTypeRequest]

    export type TipoRequestMonitorName = {
        [k in keyof typeof CTypeRequest]: (TTypeRequestEntitiesMap[typeof CTypeRequest[k]]) extends OmitEntity ? never : k
    }[keyof typeof CTypeRequest]

    type TMonitoreable = {
        1: true;
        2: false;
    }

    type IItemModule<TypeRequest extends CTypeRequest, Entity = TTypeRequestEntitiesMap[TypeRequest]> = {
        // [kE in keyof Entity]: {
        [kM in keyof TMonitoreable]: {
            // NOTE Implementar ids as number[]
            readonly GetDataList: (idsEscuelas: Array<MEscuela>, TAG?: string)
                => Promise<DataDRequest.IRequestResponseListA<Entity>[]> | DataRequestWKList<any, Entity>;
            readonly DictData: Map<number, Entity>;
            readonly IdData: TOnlyKeysTypeof<Entity, number>; // Entity[kE] extends number ? (kE & string) : never;
            readonly IsMonitorable: TMonitoreable[kM];
            /** If true: Admin creates tables in BD for module data */
            readonly SaveInLocalBD: boolean;
            // readonly CreateStorage: boolean;
            readonly Environment?: DataUtil.TEnvironment;
            __StorageAvailable?: boolean;
            readonly ForcedLoad?: boolean;
        }
        & (
            TMonitoreable[kM] extends true
            ? {
                /** Establece la frecuencia de monitoreo:
                 * Es un múltiplo para el número de vuelta en la que se encuentra el monitor.
                 *
                 * Puede impedir la primer carga de datos.
                 * @example
                 * MonitorFrecuency = 2 // Consulta datos cada 2 vueltas del monitor
                 */
                readonly MonitorFrecuency?: number;
                /**
                 * Forza una primera carga de los datos.
                */
                readonly RequestOnFirstLoad?: boolean;
            }
            : {
                /**
                 * Forza una primera carga de los datos.
                */
                readonly RequestOnFirstLoad?: true;
            }
        )
    }[keyof TMonitoreable];
    // }[keyof Entity];

    type IModuleConfig = {
        [k in TipoRequestMonitorName]: IItemModule<typeof CTypeRequest[k]>;
    }
    let modulesConfig: IModuleConfig;
    /**
     *
     * @returns
     *
     * - {
     * -      Kinder: IItemModule<CTypeRequest.Kinder, Entidades.IKinder>;
     * -      Ninio: IItemModule<CTypeRequest.Ninio, Entidades.IChild>;
     * -      ... 16 or more ...;
     * -      Ayuda: IItemModule<...>;
     * - }
     */
    export function _GetModulesConfig(): IModuleConfig {
        if (!modulesConfig || !modulesConfig.Escuela.GetDataList) {
            modulesConfig = {
                Sesion: {
                    GetDataList: _SvSesionVerificarSesion,
                    DictData: _DICC_SESION_VIGENCIA,
                    IdData: "Id",
                    IsMonitorable: true,
                    SaveInLocalBD: false
                },
                Escuela: {
                    GetDataList: _SvEscuelaObtenerLista,
                    DictData: _DICC_ESCUELA,
                    IdData: "IdKinder",
                    IsMonitorable: true,
                    MonitorFrecuency: 2,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: true
                },
                Licencia: {
                    GetDataList: _SvLicenciaObtenerLista,
                    DictData: _DICC_LICENCIA,
                    IdData: "Id",
                    IsMonitorable: true,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                    Environment: "debug",
                },
                Tutor: {
                    GetDataList: _SvTutorObtenerLista,
                    DictData: _DICC_TUTORES,
                    IdData: "IdPadre",
                    IsMonitorable: true,
                    MonitorFrecuency: 3,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: true
                },
                Grado: {
                    GetDataList: _SvGradoObtenerLista,
                    DictData: _DICC_GRADO,
                    IdData: "IdNivel",
                    IsMonitorable: true,
                    SaveInLocalBD: true
                },
                Escolaridad: {
                    GetDataList: _SvEscolaridadObtenerLista,
                    DictData: _DICC_ESCOLARIDAD,
                    IdData: "Id",
                    IsMonitorable: true,
                    MonitorFrecuency: 2,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: true
                },
                Grupo: {
                    GetDataList: _SvGrupoObtenerLista,
                    DictData: _DICC_GRUPO,
                    IdData: "IdGrupo",
                    IsMonitorable: true,
                    MonitorFrecuency: 3,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: true
                },
                HorarioAlumno: {
                    GetDataList: _SvHorarioObtenerLista,
                    DictData: _DICC_ALUMNO_HORARIO_ASIGNACION,
                    IdData: "IdHorario",
                    IsMonitorable: true,
                    MonitorFrecuency: 2,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                LogroCategoria: {
                    GetDataList: _SvLogroCategoriaObtenerLista,
                    DictData: _DICC_LOGRO_CATEGORIAS,
                    IdData: "IdCategoria",
                    IsMonitorable: true,
                    MonitorFrecuency: 3,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                Logro: {
                    GetDataList: _SvLogroObtenerLista,
                    DictData: _DICC_LOGROS,
                    IdData: "IdLogro",
                    IsMonitorable: true,
                    MonitorFrecuency: 3,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                AlumnoEstado: {
                    GetDataList: _SvAlumnoObtenerInfoBajaTemporalLista,
                    DictData: _DICC_ALUMNO_ESTADO,
                    IdData: "IdAlumno",
                    IsMonitorable: true,
                    SaveInLocalBD: true,
                    MonitorFrecuency: 3,
                    RequestOnFirstLoad: true,
                },
                Alumno: {
                    GetDataList: _SvAlumnoObtenerLista,
                    DictData: _DICC_ALUMNO,
                    IdData: "IdChild",
                    IsMonitorable: true,
                    SaveInLocalBD: true,
                },
                LogroAsignacion: {
                    GetDataList: _SvLogroObtenerListaAsignacion,
                    DictData: _DICC_LOGRO_ASIGNACIONES,
                    IdData: "IdAsignacion",
                    IsMonitorable: true,
                    SaveInLocalBD: true,
                },
                TutorAsignacion: {
                    GetDataList: _SvPadreObtenerAsignacionesAlumno,
                    DictData: _DICC_TUTOR_ASIGNACIONES,
                    IdData: "IdRegistro",
                    IsMonitorable: true,
                    SaveInLocalBD: true,
                },
                // UsuarioPermisos: null,
                Circular: {
                    GetDataList: _SvNoticiaObtenerLista,
                    DictData: _DICC_NOTICIA,
                    IdData: "IdNoticia",
                    IsMonitorable: false,
                    SaveInLocalBD: false,
                    RequestOnFirstLoad: true,
                    ForcedLoad: true
                },
                // Archivo: null,
                FinanzaCargo: {
                    GetDataList: _SvFinanzasObtenerListaCargos,
                    DictData: _DICC_FINANZAS_CARGOS,
                    IdData: "ID",
                    IsMonitorable: true,
                    SaveInLocalBD: true,
                },
                CicloEscolar: {
                    GetDataList: _SvCicloEscolarObtenerLista,
                    DictData: _DICC_CICLO_ESCOLAR,
                    IdData: "Id",
                    IsMonitorable: true,
                    SaveInLocalBD: true,
                },
                FinanzaMetodoPago: {
                    GetDataList: _SvMetodoPagoObtenerLista,
                    DictData: _DICC_METODO_PAGO,
                    IdData: "IdMetodoPago",
                    RequestOnFirstLoad: true,
                    MonitorFrecuency: 4,
                    IsMonitorable: true,
                    SaveInLocalBD: true,
                },
                FinanzaHoraExtra: {
                    GetDataList: _SvFinanzasObtenerListaHorasExtra,
                    DictData: _DICC_HORAS_EXTRAS,
                    IdData: "Id",
                    IsMonitorable: false,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                Usuario: {
                    GetDataList: _GetListUsuario,
                    DictData: _DiccUsuarios,
                    IdData: "IdUsuario",
                    IsMonitorable: false,
                    SaveInLocalBD: false,
                },
                Ayuda: {
                    GetDataList: _SvAyudaObtenerLista,
                    DictData: _DICC_AYUDA,
                    IdData: "Id",
                    IsMonitorable: false,
                    SaveInLocalBD: false,
                },
                Maestro: {
                    GetDataList: _SvMaestroObtenerLista,
                    DictData: _DICC_MAESTROS,
                    IdData: "Id",
                    IsMonitorable: true,
                    MonitorFrecuency: 8,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                EscuelaAlumnoInfoExtra: {
                    GetDataList: _GetListEscuelaAlumnoInfoExtra,
                    DictData: _DiccEscuelaAlumnoInfoExtra,
                    IdData: "Id",
                    IsMonitorable: false,
                    SaveInLocalBD: true,
                    RequestOnFirstLoad: true,
                },
                EgresoPredefinido: {
                    GetDataList: _GetListEgresoPredefinido,
                    DictData: _DictEgresosPredefinidos,
                    IdData: "Id",
                    IsMonitorable: true,
                    MonitorFrecuency: 2,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                CuentaBancaria: {
                    GetDataList: _GetListCuentaBancaria,
                    DictData: _DictCuentaBancaria,
                    IdData: "Id",
                    IsMonitorable: false,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                Proveedor: {
                    GetDataList: _GetListProveedor,
                    DictData: _DictProveedor,
                    IdData: "Id",
                    IsMonitorable: false,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                MateriaV2: {
                    GetDataList: _GetListMateriaV2,
                    DictData: _DiccMateriasV2,
                    IdData: "IdMateria",
                    IsMonitorable: false,
                    RequestOnFirstLoad: true,
                    SaveInLocalBD: false,
                },
                EgresoCategoria: {
                    GetDataList: _GetListEgresoCategoria,
                    DictData: _DictCategorias,
                    IdData: "Id",
                    IsMonitorable: false,
                    SaveInLocalBD: false,
                }
            }
        }
        return modulesConfig;
    }

    export function _GetModuleConfig<ReqID extends TipoRequestMonitorId>(idRequest: ReqID): IItemModule<ReqID> {
        return _GetModulesConfig()[CTypeRequest[idRequest] as keyof CTypeRequest] || null;
    }

    export function _ActivarServiceMonitor<ReqID extends TipoRequestMonitorId>(idRequest: ReqID, activar: boolean) {
        const item = DataModuloMain._GetModuleConfig(idRequest);
        (item.IsMonitorable as any) = activar;
    }

    // MAP

    export function _GetReqDataMapById<ReqID extends TipoRequestMonitorId>(requestID: ReqID) {
        return DataModuloMain._GetModuleConfig(requestID).DictData;
    }

    export function _GetReqDataMapByName<ReqName extends TipoRequestMonitorName>(requestName: ReqName) {
        const requestID = CTypeRequest[requestName];
        return _GetReqDataMapById(requestID);
    }

    // ARRAY

    export function _GetReqDataArrayById<ReqID extends TipoRequestMonitorId>(requestID: ReqID, sort = false) {
        let itemRequestConfig = _GetModuleConfig(requestID);
        let idKey = itemRequestConfig.IdData as string;

        let res = Array.from(itemRequestConfig.DictData.values());

        if (sort) {
            return res.sort((a, b) => (a[idKey] - b[idKey]));
        }
        return res;
    }

    export function _GetReqDataArrayByName<ReqName extends TipoRequestMonitorName>(requestName: ReqName, sort = false) {
        const requestID = CTypeRequest[requestName];
        return _GetReqDataArrayById(requestID, sort);
    }

    // GET DATA

    export function _GetItemDataById<ReqName extends TipoRequestMonitorId>(requestName: ReqName, id: number) {
        const map = _GetReqDataMapById(requestName);
        const dato = map.get(id);
        if (!dato) {
            return null;
        }
        return dato;
    }

    export function _GetItemDataByName<ReqName extends TipoRequestMonitorName>(requestName: ReqName, id: number) {
        const requestID = CTypeRequest[requestName];
        return _GetItemDataById(requestID, id);
    }

    export function _GetDataValueFieldById<ReqName extends TipoRequestMonitorId, FieldDataType extends keyof TTypeRequestEntitiesMap[ReqName]>(requestName: ReqName, id: number, field: FieldDataType) {
        const map = _GetReqDataMapById(requestName);
        const dato = map.get(id);
        if (!dato) {
            return null;
        }
        return dato[field];
    }

    export function _GetDataValueFieldByName<ReqName extends TipoRequestMonitorName, FieldDataType extends keyof TTypeRequestEntitiesMap[(typeof CTypeRequest)[ReqName]]>(requestName: ReqName, id: number, field: FieldDataType) {
        const requestID = CTypeRequest[requestName];
        return _GetDataValueFieldById(requestID, id, field);
    }
}
